import {
  Modal,
  ModalBody,
  ModalFoot,
  ModalHead,
  Text,
} from '@dixa/lib-shared-habla';
import { useMemo } from 'react';

import { createAppModal } from 'utils/modal';

import { setLocalStorageDesktopAppNoticeCache } from '../../../../utils/localStorageDesktopAppNoticeCache/localStorageDesktopAppNoticeCache';

import styles from './desktopAppNoticeModal.module.scss';

const desktopAppDownloadUrls = {
  windows: 'https://www.dixa.com/download/windows',
  mac: 'https://www.dixa.com/download/mac',
  fallback: 'https://www.dixa.com/download/',
};

export const DesktopAppNoticeModal = createAppModal(
  { type: 'app:desktopAppNotice' },
  ({ isOpen, modal, hide }): JSX.Element => {
    const daysToPostpone = modal.arg.daysToPostpone;

    const handleCancel = () => {
      if (daysToPostpone !== undefined) {
        setLocalStorageDesktopAppNoticeCache({
          daysToPostpone,
        });
      }

      hide();
    };

    const handleConfirm = () => {
      if (isPlatformWindows) {
        window.open(desktopAppDownloadUrls.windows, '_blank');
      } else if (isPlatformMac) {
        window.open(desktopAppDownloadUrls.mac, '_blank');
      } else {
        window.open(desktopAppDownloadUrls.fallback, '_blank');
      }

      hide();
    };

    const isPlatformWindows = useMemo(() => {
      return (
        (navigator as { platform: string }).platform
          .toUpperCase()
          .indexOf('WIN') !== -1
      );
    }, []);

    const isPlatformMac = useMemo(() => {
      return (
        (navigator as { platform: string }).platform
          .toUpperCase()
          .indexOf('MAC') !== -1
      );
    }, []);

    return (
      <Modal isOpen={isOpen} onClose={handleCancel} className={styles.modal}>
        <ModalHead
          title="Dixa Desktop App update required"
          onClose={handleCancel}
        />

        <ModalBody>
          <Text.Paragraph>
            You are running an unsupported version of Dixa that will{' '}
            <b>stop functioning</b> the 8th of May 2023.
          </Text.Paragraph>
          <br />
          <Text.Paragraph>
            Update as soon as possible to work uninterrupted
          </Text.Paragraph>

          {isPlatformWindows && (
            <>
              <br />
              <Text.Paragraph>
                If you are using the non auto updating Dixa Desktop App (MSI
                standalone), see{' '}
                <Text.ExternalLink
                  href="https://support.dixa.help/en/articles/151-deploy-dixa-via-windows-installer-msi"
                  target="_blank"
                  rel="noreferrer"
                >
                  Dixa Help Center
                </Text.ExternalLink>{' '}
                for more information or contact your system administrator.
              </Text.Paragraph>
            </>
          )}
        </ModalBody>

        <ModalFoot
          confirmOnClick={handleConfirm}
          cancelOnClick={handleCancel}
          confirmName={
            isPlatformMac
              ? 'Download for Mac'
              : isPlatformWindows
                ? 'Download for Windows'
                : 'Visit download page'
          }
          cancelName={
            daysToPostpone > 0
              ? `Remind me in ${daysToPostpone} day${
                  daysToPostpone > 1 ? 's' : ''
                }`
              : null
          }
        />
      </Modal>
    );
  },
);
